export var WIDTHS = {
  MENU: {
    MOBILE: '27.2rem',
    TABLET: '27.2rem',
    DESKTOP: '6.4rem'
  },
  EXPANDED_MENU: {
    MOBILE: '27.2rem',
    TABLET: '27.2rem',
    DESKTOP: '18.4rem'
  },
  SUB_MENU: {
    MOBILE: '27.2rem',
    TABLET: '27.2rem',
    DESKTOP: '22rem'
  },
  ITEM: {
    MOBILE: '4.8rem',
    TABLET: '4.8rem',
    DESKTOP: '4.8rem'
  }
};